'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Quiz = require('./Quiz.scss');

var _Quiz2 = _interopRequireDefault(_Quiz);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniqueID = function uniqueID() {
  return Math.floor(Math.random() * Date.now()).toString();
};

var QuizMCQ = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QuizMCQ, _Component);

  function QuizMCQ(props) {
    (0, _classCallCheck3.default)(this, QuizMCQ);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuizMCQ.__proto__ || (0, _getPrototypeOf2.default)(QuizMCQ)).call(this, props));

    _this.handleAddQuestionAnswer = function () {
      var _this$props = _this.props,
          answer = _this$props.answer,
          onChange = _this$props.onChange;


      answer.possibleAnswers.push({
        _id: uniqueID(),
        content: 'Nouvelle réponse...'
      });

      onChange(answer);
    };

    _this.handleSetCorrectAnswer = function (answerIndex) {
      var _this$props2 = _this.props,
          answer = _this$props2.answer,
          onChange = _this$props2.onChange;

      answer.correctAnswerId = answer.possibleAnswers[answerIndex]._id;

      onChange(answer);
    };

    _this.handleDeleteQuestionAnswer = function (index) {
      var _this$props3 = _this.props,
          answer = _this$props3.answer,
          onChange = _this$props3.onChange;

      if (window.confirm('Etes-vous sûr de vouloir supprimer cette réponse ?')) {
        answer.possibleAnswers.splice(index, 1);
      }
      onChange(answer);
    };

    return _this;
  }

  (0, _createClass3.default)(QuizMCQ, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          answer = _props.answer,
          innerHTML = _props.innerHTML,
          startEditingMCQAnswer = _props.startEditingMCQAnswer;


      return _react2.default.createElement(
        'ul',
        { style: { padding: 0, listStyle: 'none' } },
        answer.possibleAnswers.map(function (possibleAnswer, index) {
          return _react2.default.createElement(
            'li',
            { style: { border: '1px solid #000', padding: '10px 20px', listStyle: 'none', marginBottom: '10px', alignItems: 'center', display: 'flex' }, key: index },
            _react2.default.createElement('input', {
              type: 'checkbox',
              checked: answer.correctAnswerId === possibleAnswer._id,
              style: { marginRight: '8px' },
              onClick: function onClick() {
                return _this2.handleSetCorrectAnswer(index);
              }
            }),
            _react2.default.createElement(
              'div',
              { className: _Quiz2.default.answerContent, onClick: function onClick() {
                  return startEditingMCQAnswer(index);
                } },
              innerHTML(possibleAnswer.content)
            ),
            answer.possibleAnswers.length > 2 && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.handleDeleteQuestionAnswer(index);
                }, style: { cursor: 'pointer' } },
              '\u274C'
            )
          );
        }),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'button',
            { className: _Quiz2.default.addAnswerButton, onClick: this.handleAddQuestionAnswer },
            'Ajouter une r\xE9ponse'
          )
        )
      );
    }
  }]);
  return QuizMCQ;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  answer: _react.PropTypes.object.isRequired,
  innerHTML: _react.PropTypes.func.isRequired,
  startEditingMCQAnswer: _react.PropTypes.func.isRequired
}, _temp);
exports.default = QuizMCQ;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Quiz/QuizMCQ.js
// module id = 1196
// module chunks = 0